'use client'

import { Box, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import Link from '@/components/common/Link'
import { getLocaleName } from '@/utils/locale'
import { colors } from '@/theme/colors'

const linkSx = {
  border: 'none',
  fontWeight: 'normal',
  textTransform: 'initial',
  fontStretch: 'initial',
  alignSelf: 'flex-start',
  lineHeight: 1.66,
  fontSize: '1em',
  color: `${colors.accent5} !important`,
  textDecoration: 'none',
  '&:hover, &:focus, &:focus-visible': {
    color: `${colors.accent5} !important`
  }
} as const

const columnSx = {
  display: 'flex',
  flexDirection: 'column',
  mb: '2em'
} as const

const LocaleLink = ({ locale }: { locale: string }) => (
  <Link href={`/${locale}/`} title={getLocaleName(locale)} lang={locale} sx={linkSx}>
    {getLocaleName(locale)}
  </Link>
)

export default function LocalesContent() {
  const { t } = useTranslation()

  return (
    <Box sx={{ pt: '4em', px: { xs: 2, sm: 4, md: 0 }, mx: 'auto', width: { xs: '100%', md: '80%' } }}>
      <Typography align='center' variant='h2' component={'h1'} sx={{ textTransform: 'none !important' }}>
        {t('This Site In Other Countries / Regions')}
      </Typography>

      <Grid container sx={{ pt: '2em' }}>
        <Grid size={{ xs: 12, md: 4 }} sx={columnSx}>
          <Typography variant='h5'>{t('America')}</Typography>
          <LocaleLink locale='en-us' />
          <LocaleLink locale='en-ca' />
          <LocaleLink locale='fr-ca' />
          <LocaleLink locale='es-mx' />
        </Grid>

        <Grid size={{ xs: 12, md: 4 }} sx={columnSx}>
          <Typography variant='h5'>{t('Europe')}</Typography>
          <LocaleLink locale='en-gb' />
          <LocaleLink locale='fr-fr' />
          <LocaleLink locale='es-es' />
        </Grid>

        <Grid size={{ xs: 12, md: 4 }} sx={columnSx}>
          <Typography variant='h5'>{t('Asia + Pacific')}</Typography>
          <LocaleLink locale='en-au' />
          <LocaleLink locale='en-nz' />
        </Grid>
      </Grid>
    </Box>
  )
}
